export const time = {
  spin: 0.4,
  regular: 1.5,
  big: 2.5,
  ultra: 2.5,
  mega: 2.5,
}
